module.exports = __webpack_public_path__ + "img/hehe.c7876904.png";